<template>
    <div>
      <b-form-group id="input-group-1" label="Nombre del rol:" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="rol.description"
          name="nombre"
          v-validate="'required|min:3 '" 
          :state="$parent.validateState('nombre')"
          placeholder="Tu respuesta"
        ></b-form-input>

        <b-form-invalid-feedback>
          {{  errors.first('nombre') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-checkbox 
        v-model="permisos.admin"
        switch 
        stacked
      >
        {{ menus[0].descripcion}}
      </b-form-checkbox>
      <b-form-checkbox 
        v-model="permisos.vendedor"
        switch 
        stacked
      >
       {{ menus[1].descripcion}}
      </b-form-checkbox>
      <b-form-checkbox 
        v-model="permisos.preprensa"
        switch 
        stacked
      >
       {{ menus[2].descripcion}}
      </b-form-checkbox>
      <b-form-checkbox 
        v-model="permisos.ingenieria"
        switch 
        stacked
      >
        {{ menus[3].descripcion}}
      </b-form-checkbox>
      <b-form-checkbox 
        v-model="permisos.bitacora"
        switch 
        stacked
      >
        {{ menus[4].descripcion}}
      </b-form-checkbox>
      
      <b-form-checkbox 
        v-model="permisos.google"
        switch 
        stacked
      >
        {{ menus[6].descripcion}}
      </b-form-checkbox>
      
      <b-form-checkbox 
        v-model="permisos.reporte"
        switch 
        stacked
      >
        {{ menus[10].descripcion}}
      </b-form-checkbox>

      <b-form-checkbox 
        v-model="permisos.tickets"
        switch 
        stacked
      >
        {{ menus[11].descripcion}}
      </b-form-checkbox>

      <b-form-checkbox 
        v-model="permisos.ticketsmantenimiento"
        switch 
        stacked
      >
        {{ menus[12].descripcion}}
      </b-form-checkbox>


      <div class="card mt-3">
        <vswitch  v-model="permisos.sapweb" :key="spc1">{{ menus[7].descripcion}}</vswitch>
        <vswitch  v-model="permisos.sapwebvendedor" identifier="customSwitch2" :key="spc2">{{ menus[9].descripcion}}</vswitch>
        <vswitch  v-model="permisos.sapwebadmin" identifier="customSwitch3" :key="spc3">{{ menus[8].descripcion}}</vswitch>
      </div>

    </div>
</template>

<script>
  import vswitch from '@/components/partials/vswitch'  
  import {mapActions, mapState, mapGetters, mapMutations} from 'vuex'
  import Vue from 'vue'
    export default {
      components:{
             vswitch
        },
      inject:['$validator'],//para que el padre inyecte el validador a este componente hijo.
      
      props:{
        rol:{
          type: Object,
          required:true
        },
        permisos:{
          type: Object,
          required:true
        },
        
      },
      data() {
            return {
              spc1: 0,
              spc2: 100,
              spc3: 1000,
            }
      },
      mounted(){
        this.init()
      },
      computed:{
        ...mapState('menus',['menus']),
      },
      watch:{
        "permisos.sapwebvendedor": function(newVal, oldVal) {
          if(this.permisos.sapwebvendedor == true){
            console.warn(this.permisos.sapwebvendedor)
            this.permisos.sapweb = false
            this.permisos.sapwebadmin = false
            this.spc1++
            this.spc3++          }
        },
        "permisos.sapwebadmin": function(newVal, oldVal) {
          if(this.permisos.sapwebadmin == true){
            console.warn("admin" + this.permisos.sapwebadmin)
            this.permisos.sapweb = false
            this.permisos.sapwebvendedor = false
            this.spc1++
            this.spc2++          }
        },
        "permisos.sapweb": function(newVal, oldVal) {
          if(this.permisos.sapweb == true){
            console.warn(this.permisos.sapweb)
            this.permisos.sapwebadmin = false
            this.permisos.sapwebvendedor = false
            this.spc3++
            this.spc2++          }
        },
      },
      methods:{
        ...mapActions({
          _fetchMenus: 'menus/fetchMenus',
        }),
        init(){
          this._fetchMenus()
        }
      },
      

        
    }
</script>

<style lang="scss" scoped>

</style>